/// <reference path='../_all.ts' />

module solution {
  'use strict';

  export class MeasuringTask {
    constructor(
      public Name: string,
      public Id: number,
      public UrlKey : string,
      public MeasuringTaskGroups: number[],
      public Products: number[]
      ) { }
  }
}
